// #market-modal is shared by the #find-dropdown (nav) and #find-menu
// (footer) triggers. Each trigger declares its full modal title and which
// listing type it represents via data-market-title/data-market-slug (slug
// values are rendered from urlsuffix in the template, so they can't drift
// from URLPATTERN_SUFFIX_SLUGS); clicking one retitles the modal and repoints
// every market link at that listing type.
(function () {
    var modal = document.getElementById('market-modal');
    if (!modal) return;

    var label = document.getElementById('market-modal-label');
    var marketLinks = modal.querySelectorAll('[data-base-href]');

    function applyMarketType(title, slug) {
        if (slug === undefined) return;

        if (title && label) label.textContent = title;

        marketLinks.forEach(function (link) {
            link.setAttribute('href', link.dataset.baseHref + slug);
        });
    }

    // Also index each listing type's title by its slug, so the listing-link
    // handling below can reuse the Find menu's own wording instead of repeating it.
    var titleBySlug = {};

    document.querySelectorAll('[data-bs-target="#market-modal"][data-market-slug]').forEach(function (trigger) {
        var slug = trigger.dataset.marketSlug;

        trigger.addEventListener('click', function () {
            applyMarketType(trigger.dataset.marketTitle, slug);
        });

        // Skip the "Select a Region" trigger -- its slug is empty on purpose.
        if (slug && !(slug in titleBySlug)) {
            titleBySlug[slug] = trigger.dataset.marketTitle;
        }
    });

    // Turn button-style calls to action that point at a region-less listing index
    // into triggers for this modal: there's no single page to land on, so the
    // visitor picks a market first. The paths come from
    // #market-modal-listing-paths (see the comment in inc_market_modal.html) and
    // are matched exactly, so deeper listing URLs like
    // /new-homes/ohio/cincinnati/ stay ordinary links.
    //
    // Scoped to .btn anchors and buttons on purpose. Plain inline links -- the
    // breadcrumb trail above all -- are navigation, and should keep navigating.
    var listingSlugByPath = {};
    var pathConfig = document.getElementById('market-modal-listing-paths');
    if (pathConfig) {
        try {
            listingSlugByPath = JSON.parse(pathConfig.textContent);
        } catch (err) {
            listingSlugByPath = {};
        }
    }

    // This page's own listings-nav base url (see the comment in
    // inc_market_modal.html) -- truthy and not the bare sitewide root only on a
    // market/geomarket page, e.g. "/new-homes/georgia/atlanta/".
    var pageRegionBase = pathConfig && pathConfig.dataset.regionBase;
    if (pageRegionBase === '/new-homes/') pageRegionBase = null;

    function listingSlugForPath(pathname) {
        if (pathname in listingSlugByPath) return listingSlugByPath[pathname];
        // Authored links routinely drop the trailing slash. Django would redirect
        // that to the same page, so treat it as the same match rather than letting
        // it navigate to a listing index with no region.
        var withSlash = pathname + '/';
        if (withSlash in listingSlugByPath) return listingSlugByPath[withSlash];
        return null;
    }

    document.addEventListener('click', function (e) {
        // Leave modified and non-primary clicks alone -- those are asking for a new
        // tab or window, which the modal can't honour.
        if (e.defaultPrevented || e.button !== 0) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

        // button[data-href] is here for the button case; nothing in the theme uses
        // it yet, so today this only ever matches a .btn anchor.
        var trigger = e.target.closest && e.target.closest('a.btn[href], button[data-href]');
        if (!trigger || trigger.target === '_blank' || trigger.hasAttribute('download')) return;
        // The region links inside the modal are real destinations.
        if (trigger.closest('#market-modal')) return;
        if (trigger.closest('[data-market-modal-skip]')) return;

        var url;
        try {
            url = new URL(trigger.getAttribute('href') || trigger.dataset.href, window.location.href);
        } catch (err) {
            return;
        }
        // Only our own listing indexes -- never hijack an off-site link that
        // happens to share the path.
        if (url.origin !== window.location.origin) return;

        var slug = listingSlugForPath(url.pathname);
        if (slug === null) return;

        // A region is already known -- from the page itself (a market/geomarket
        // page) or from a prior visit's saved cookie (savedHref, set below) -- so
        // there's nothing to ask; send the click straight to that region's matching
        // listing page instead of opening the modal. Rewriting the anchor's own
        // href and letting the click continue keeps it a real navigation (new-tab,
        // status-bar preview, and screen readers all still work), the same reason
        // linkify() below builds a real <a> rather than redirecting from script.
        var knownRegionBase = pageRegionBase || savedHref;
        if (knownRegionBase) {
            trigger.setAttribute('href', knownRegionBase + slug);
            return;
        }

        var Modal = window.bootstrap && window.bootstrap.Modal;
        if (!Modal) return;   // let the link navigate rather than dead-ending

        applyMarketType(titleBySlug[slug], slug);
        e.preventDefault();
        Modal.getOrCreateInstance(modal).show();
    });

    // Remember the chosen region so it can be restored as the "Select a
    // Region" label on future visits.
    marketLinks.forEach(function (link) {
        link.addEventListener('click', function () {
            oi.utils.cookie.set('user_region', link.textContent.trim());
        });
    });

    // Turns a modal trigger into a real link to `href`. Swapped for an <a> rather than
    // navigating from a click handler so it behaves like a link: cmd/middle-click opens a
    // tab, the status bar shows the destination, and assistive tech announces a link rather
    // than a button. The modal's data-bs-* attributes are deliberately not carried over,
    // which is what stops it opening the modal.
    function linkify(trigger, href) {
        var link = document.createElement('a');
        link.className = trigger.className;
        if (trigger.id) link.id = trigger.id;
        link.href = href;
        link.innerHTML = trigger.innerHTML;
        trigger.replaceWith(link);
        return link;
    }

    var savedRegion = oi.utils.cookie.val('user_region');
    var selectRegion = document.getElementById('nav-select-region');
    var selectRegionLabel = selectRegion && selectRegion.querySelector('[data-market-label]');

    if (savedRegion && selectRegionLabel) {
        // Update only the label span's text, not the button's full innerHTML --
        // it also holds the fa-location-dot icon, which textContent would wipe out.
        selectRegionLabel.textContent = savedRegion;

        // #nav-select-region itself deliberately stays a modal trigger even once a
        // region is remembered -- it's the current-location display, and clicking it
        // is how a visitor changes region, so it always has to open the picker rather
        // than ever becoming a direct link to that region's own page.
        //
        // The cookie stores the region's label, so the permalink comes from the matching
        // link in the modal -- data-base-href is the region's own page, where href has a
        // listing slug appended to it.
        var savedLink = null;
        marketLinks.forEach(function (link) {
            if (!savedLink && link.textContent.trim() === savedRegion) savedLink = link;
        });
        var savedHref = savedLink && savedLink.dataset.baseHref;

        if (savedHref) {
            // The rest of the nav's Find menu goes straight to that region's own listing
            // pages: the modal only exists to ask which region, and the answer is
            // already on file. Each trigger's slug is the listing type it stands for, so
            // the region's base permalink plus that slug is its page -- Communities ->
            // /new-homes/<state>/<region>/communities/, and so on.
            //
            // #nav-select-region is excluded even though it now carries a real
            // (Communities) slug too, for the reason above -- see the comment there.
            //
            // Scoped to the nav menu on purpose. The footer's #find-menu carries the same
            // four triggers and keeps opening the modal, since a visitor reading the
            // footer is as likely to be after a different region as their saved one.
            var findMenu = document.getElementById('find-dropdown-menu');
            if (findMenu) {
                findMenu.querySelectorAll('[data-market-slug]').forEach(function (trigger) {
                    var slug = trigger.dataset.marketSlug;
                    if (slug && trigger.id !== 'nav-select-region') linkify(trigger, savedHref + slug);
                });
            }
        }
        // No match -- a region since renamed or removed -- leaves the modal triggers in
        // place so the visitor can pick again.
    }
}());
